module.exports = __webpack_public_path__ + "img/visualiser.95fa3fcf.svg";